import { render, staticRenderFns } from "./transaction-door-to-door.vue?vue&type=template&id=a10ab162&"
import script from "./transaction-door-to-door.vue?vue&type=script&lang=js&"
export * from "./transaction-door-to-door.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports